import { playerStateType } from "../store";

const player = {
  namespaced: true,
  state: {
    // 播放信息
    playerInfo: null,
    // 播放信息弹窗显示状态
    playerInfoDialogVisible: false,
  } as playerStateType,
  getters: {
    // 播放器相关的 getters
    playerInfo: (state: playerStateType) => {
      return state.playerInfo;
    },
    playerInfoDialogVisible: (state: playerStateType) => {
      return state.playerInfoDialogVisible;
    },
  },
  mutations: {
    // 重置 state 为默认值（退出登录时使用）
    resetState(state: playerStateType) {
      state.playerInfo = null;
      state.playerInfoDialogVisible = false;
    },
    set_playerInfo(state: playerStateType, data: any) {
      state.playerInfo = data;
    },
    set_playerInfoDialogVisible(state: playerStateType, visible: boolean) {
      state.playerInfoDialogVisible = visible;
    },
  },
};

export default player;

